export default {
  apiKey: "AIzaSyCJpw0qbmBHraXB38I_MHgI31vBde8LVQ4",
  authDomain: "leamhquiz.firebaseapp.com",
  databaseURL: "leamhquiz.firebaseio.com",
  projectId: "leamhquiz",
  storageBucket: "leamhquiz.appspot.com",
  messagingSenderId: "947180842936"
};
